import Component from '../components/design'

const Design = () => <Component />

export default Design;